import { getFeed } from "./getFeed"
import { WordPressObject } from "@/shared/config/api-config"

interface IStatsResponse {
	minPrice: number
	maxPrice: number
	minSquare: number
	maxSquare: number
	roomsSet: number[]
	total: number
}

export async function getFeedStats(): Promise<IStatsResponse | null> {
	try {
		const data = await getFeed()
		if (!data) return null
		const objects = (data.objects || []) as WordPressObject[]
		if (!objects.length) {
			return null
		}
		const prices = objects.map(o => Number(o.price)).filter(n => !Number.isNaN(n))
		const squares = objects.map(o => Number(o.square)).filter(n => !Number.isNaN(n))
		const rooms = Array.from(
			new Set(objects.map(o => Number(o.rooms)).filter(n => !Number.isNaN(n)))
		).sort((a, b) => a - b)

		return {
			minPrice: Math.min(...prices),
			maxPrice: Math.max(...prices),
			minSquare: Math.min(...squares),
			maxSquare: Math.max(...squares),
			roomsSet: rooms,
			total: data.count,
		}
	} catch (e: any) {
		return e?.message || "Не удалось получить статистику"
	}
}
